import {
  SortDropdown,
  SortDropdownProps,
} from 'modules/shared-components/filters/sort-dropdown';
import { MarketplaceSortOptions } from '../../hooks/useStrategiesState';

const SORT_OPTIONS = [
  {
    label: 'Highest PnL from Followers',
    value: MarketplaceSortOptions.Last30DaysFollowersPnL,
  },
  {
    label: 'Most Popular',
    value: MarketplaceSortOptions.MostPopular,
  },
  {
    label: 'Highest Returns',
    value: MarketplaceSortOptions.HighestReturns,
  },
  {
    label: 'Newest',
    value: MarketplaceSortOptions.Newest,
  },
  {
    label: 'Oldest',
    value: MarketplaceSortOptions.Oldest,
  },
];

export function MarketplaceSort(
  props: Omit<SortDropdownProps<string>, 'options'>
) {
  return <SortDropdown {...props} options={SORT_OPTIONS} />;
}
